import React from "react";
import styled from "styled-components";
import { PositionResult } from "common/position/dto/PositionResult";
import PositionSingleNav from "components/common/position/PositionSingleNav";
import PositionPlay from "components/common/position/PositionPlay";
import { staticContentPath } from "common/static_content_common";

type PositionReadProps = {
  position: PositionResult;
};

const PositionRead = ({ position }: PositionReadProps) => {
  return (
    <div>
      <DivField>{position.datum.toDateString()}</DivField>
      <DivField>{position.title}</DivField>
      <DivField>
        {position.fileName && (
          <PositionPlay
            filePath={staticContentPath(position.fileName)}
            autoPlay={false}
            muted={true}
            width={500}
          />
        )}
      </DivField>

      <DivNav>
        <PositionSingleNav position={position} hideReadNav={true} />
      </DivNav>
    </div>
  );
};

const DivField = styled.div`
  margin-top: 0.5rem;
  font-size: 1.2rem;

  &&&:first-of-type {
    margin-top: 0rem;
  }
`;

const DivNav = styled.div`
  margin-top: 1.5rem;
`;

export default PositionRead;
